import * as React from "react"
import {graphql, Link, useStaticQuery} from "gatsby"

import logo from "../images/logo-oneline-white.svg";

const Header = ({noBanner}) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <header id="header-wrap">
      <div className={["navigation", noBanner && 'nobanner'].join(' ')}>
        <div className="container">
          <nav className="navbar navbar-expand-lg">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
            </button>
            <Link className="navbar-brand" to="/">
              <img src={logo} alt={data.site.siteMetadata?.title || `Title`}/>
            </Link>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <Link className="page-separate" to="/">Home</Link>
                </li>
                <li className="nav-item">
                  <Link className="page-scroll" to="/#about">About</Link>
                </li>
                <li className="nav-item">
                  <Link className="page-separate" to="/speakers">Speakers</Link>
                </li>
                <li className="nav-item">
                  <Link className="page-separate" to="/schedule">Schedule</Link>
                </li>
                <li className="nav-item">
                  <Link className="page-scroll" to="/#sponsors">Sponsors</Link>
                </li>
                <li className="nav-item">
                  <Link className="page-separate" to="/jobs">Jobs</Link>
                </li>
                <li className="nav-item">
                  <Link className="page-scroll" to="/#coc">Code of Conduct</Link>
                </li>
                <li className="nav-item">
                  <Link className="page-scroll" to="/#team">Team</Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header
